<template>
	<v-dialog :value="value" max-width="560" @input="$emit('input', $event)">
		<v-card>
			<v-card-title class="pa-4">
				<v-icon left>mdi-account-multiple-plus</v-icon>
				Condividi con utenti del portale
			</v-card-title>
			<v-divider></v-divider>

			<v-card-text class="pa-4">
				<p class="caption grey--text mb-3">
					Gli utenti selezionati vedranno questo elemento in sola lettura.
					Per le cartelle vale anche per il contenuto, comprese le
					sottocartelle e i file aggiunti in seguito.
				</p>

				<div v-if="loading" class="text-center py-6">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>

				<template v-else>
					<v-alert v-if="!candidates.length" type="info" text dense class="mb-0">
						Questa azienda non ha utenti del portale.
					</v-alert>

					<v-list v-else dense class="py-0">
						<v-list-item v-for="c in candidates" :key="c.id" @click="toggle(c.id)">
							<v-list-item-action class="my-1">
								<v-checkbox :input-value="selected.includes(c.id)" @click.stop="toggle(c.id)"></v-checkbox>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>{{ c.name }}</v-list-item-title>
								<v-list-item-subtitle>{{ etichettaRuolo(c.role) }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</template>

				<v-alert v-if="message" :type="messageType" text dense class="mt-3 mb-0">
					{{ message }}
				</v-alert>
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions class="pa-3">
				<v-spacer></v-spacer>
				<v-btn text @click="$emit('input', false)">Annulla</v-btn>
				<v-btn color="primary" :loading="saving" :disabled="loading || loadFailed || saving || !shareableId" @click="save">Salva</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'portal-share-dialog',
	props: {
		value: { type: Boolean, default: false },
		companyId: { type: Number, required: true },
		tipo: { type: String, required: true },
		shareableId: { type: Number, default: null }
	},
	data() {
		return {
			loading: false,
			saving: false,
			candidates: [],
			selected: [],
			message: '',
			messageType: 'info',
			loadFailed: false
		}
	},
	computed: {
		url() {
			return 'portalshares/' + this.companyId + '/' + this.tipo + '/' + this.shareableId
		}
	},
	watch: {
		value(aperto) {
			if (aperto && this.shareableId) {
				this.load()
			}
		}
	},
	methods: {
		etichettaRuolo(ruolo) {
			const mappa = { limited: 'Limitato', user: 'Utente', manager: 'Manager' }
			return mappa[ruolo] || ruolo
		},
		toggle(id) {
			const i = this.selected.indexOf(id)
			if (i === -1) {
				this.selected.push(id)
			} else {
				this.selected.splice(i, 1)
			}
		},
		load() {
			this.loading = true
			this.message = ''
			this.messageType = 'info'
			// Azzerati anche qui, non solo nel data() iniziale: se la GET fallisce
			// per l'elemento B dopo che l'operatore aveva gia' selezionato dei
			// destinatari per l'elemento A (dialogo riaperto su un elemento diverso),
			// senza questo reset le caselle di A restano spuntate e Salva le
			// applicherebbe a B senza che nessuno le abbia scelte.
			this.candidates = []
			this.selected = []
			this.loadFailed = false
			this.axios.get(this.url).then(response => {
				const d = response.data.data || {}
				this.candidates = d.candidates || []
				this.selected = (d.recipients || []).slice()
				this.loading = false
			}).catch(() => {
				this.loading = false
				this.loadFailed = true
				this.messageType = 'error'
				this.message = 'Impossibile leggere le condivisioni.'
			})
		},
		save() {
			// Guardia anche qui, non solo sul :disabled del bottone: stesso
			// pattern di SettingsStorage.refresh(), per non fare affidamento
			// solo sulla UI contro i doppi click. Proteggiamo anche dal caricamento fallito.
			if (this.saving || !this.shareableId || this.loadFailed) return
			this.saving = true
			this.message = ''
			this.messageType = 'info'
			this.axios.put(this.url, { portal_user_ids: this.selected }).then(() => {
				this.saving = false
				this.$emit('saved', this.selected.length)
				this.$emit('input', false)
			}).catch(e => {
				this.saving = false
				this.messageType = 'error'
				this.message = (e.response && e.response.data && e.response.data.message) ||
					'Impossibile salvare le condivisioni.'
			})
		}
	}
}
</script>
